import { render, staticRenderFns } from "./VerticalBrandTileGrid.vue?vue&type=template&id=42f5619a&scoped=true&"
import script from "./VerticalBrandTileGrid.vue?vue&type=script&lang=ts&"
export * from "./VerticalBrandTileGrid.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalBrandTileGrid.vue?vue&type=style&index=0&id=42f5619a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5619a",
  null
  
)

export default component.exports